<div class="ui-component" [ngClass]="component | componentClasses" >
  <div class="ui-component__content container">
    <div #childrenWrapper class="ui-component__children" *ngIf="component.children">
      <ng-container>
        <ng-content></ng-content>
      </ng-container>
    </div>
  </div>
</div>
